import * as React from 'react';
import { Button } from '@blueprintjs/core';
export function CreateButton(_a) {
    var onClick = _a.onClick, title = _a.title, _b = _a.bottom, bottom = _b === void 0 ? 60 : _b, _c = _a.right, right = _c === void 0 ? 24 : _c, _d = _a.zIndex, zIndex = _d === void 0 ? 10 : _d;
    return (React.createElement("div", { style: {
            position: 'absolute',
            bottom: bottom,
            right: right,
            zIndex: zIndex
        } },
        React.createElement(Button, { large: true, onClick: onClick, icon: "plus", intent: "success", text: title })));
}
//# sourceMappingURL=create_button.js.map